import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { useTheme } from '../context/ThemeContext';

const Footer = () => {
  const { isDark } = useTheme();

  return (
    <footer className={isDark ? 'bg-dark-bg' : 'bg-light-bg'} data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <Logo />
            <p className={`mt-4 text-sm leading-relaxed ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
              Seamless Integration, Infinite Possibilities. Your trusted partner for Power Platform, NetSuite, Xero, and custom enterprise solutions.
            </p>
          </div>

          <div>
            <h4 className="text-brand-primary font-semibold mb-4 font-manrope">Power Platform</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  Power Apps
                </Link>
              </li>
              <li>
                <Link to="/services" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  Power Automate
                </Link>
              </li>
              <li>
                <Link to="/services" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  Copilot Studio
                </Link>
              </li>
              <li>
                <Link to="/services" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  Power BI
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-brand-primary font-semibold mb-4 font-manrope">Integrations</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  Xero Integration
                </Link>
              </li>
              <li>
                <Link to="/services" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  NetSuite Integration
                </Link>
              </li>
              <li>
                <Link to="/services" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  Azure Services
                </Link>
              </li>
              <li>
                <Link to="/services" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  Custom APIs
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-brand-primary font-semibold mb-4 font-manrope">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/industries" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  Industries
                </Link>
              </li>
              <li>
                <Link to="/contact" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  Contact
                </Link>
              </li>
              <li>
                <a href="#" className={`text-sm transition-colors hover:text-brand-primary ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className={`border-t pt-8 text-center ${isDark ? 'border-white/5' : 'border-black/5'}`}>
          <p className={`text-sm ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
            © 2026 SerendiTech. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;